var singleEventBlock = {
    $singleEventBlock: $('.single-event-block'),
    $submitButton: $('.submitButton'),
    $mobileButton: $('.mobileButton'),
    $stepButton: $('.stepbutton'),
    departureNextStep: false,
    icon: window.baseUrl + '/wp-content/themes/party_tours/assets/img/icons/icon-maps.png',
    locationIcon:
        window.baseUrl + '/wp-content/themes/party_tours/assets/img/icons/icon-maps-location.png',
    init: function() {
        var _this = this;
        if (!_this.$singleEventBlock.length) {
            return;
        }

        //some general this and that reference inits
        _this.showAvailableTicket.init(_this);
        _this.helpers.init(_this);
        _this.googleMap.init(_this);

        //some Jquery selector registers
        _this.$accordionRow = $('.accordion-row');
        _this.$selectDepartureLocation = _this.$singleEventBlock.find(
            'select[name="departure-location"]'
        );
        _this.$selectTicketType = _this.$singleEventBlock.find('select[name="ticket-type"]');
        _this.$selectTicketAmount = _this.$singleEventBlock.find('select[name="quantity"]');
        _this.$amountBlock = _this.$singleEventBlock.find('.amount-block');
        _this.$amoundBlockSelect = _this.$amountBlock.find('select');

        //register the available tickets
        _this.ticketTypeObject = window.availableTickets;

        //init listeners
        _this.listener();

        _this.setPageByLocation();
    },

    /*
      Set map and type ticket by location
     */
    setPageByLocation: function() {
        var _this = this;
        var locationId = _this.$selectDepartureLocation.val();

        if (!locationId) {
            return;
        }

        _this.showAvailableTicket.getAmount(locationId);
        _this.googleMap.setMap(locationId);
    },

    listener: function() {
        var _this = this;
        _this.ticketForm = document.getElementById('ticketOrder');

        $('.confirm-ticket-btn').on('click', function(e) {
            e.preventDefault();
            $('.step-3').addClass('active');
            $(this).removeClass('active');
        });

        $('.next-step-btn').on('click', function(e) {
            e.preventDefault();

            if ($(this).hasClass('d-step-1')) {
                $('.d-step-1').removeClass('active');
                $('.d-step-2').addClass('active');
                if ($(window).width() < 767) {
                    $('.d-step-2.next-step-btn').addClass('active');
                    $('.submit[name="submitButton"].mobile').removeClass('active');
                    $('.submit[name="submitButton"].desktop').removeClass('active');
                } else {
                    $('.d-step-2.next-step-btn').removeClass('active');
                    $('.submit[name="submitButton"].desktop').addClass('active');
                    $('.d-step-3.routeinfo').addClass('active');
                }
            } else if ($(this).hasClass('d-step-2')) {
                if ($(window).width() < 767) {
                    $('.d-step-2').removeClass('active');
                    $('.step-3-text.d-step-3').addClass('active');
                    $('.d-step-3.routeinfo').addClass('active');
                    $('button.d-step-3').addClass('active');
                } else {
                    $('.d-step-2').addClass('active');
                    $('.next-step-btn.d-step-2').removeClass('active');
                    $('.prev-step-btn.d-step-2').removeClass('active');
                }
            }
        });

        $('.prev-step-btn').on('click', function(e) {
            e.preventDefault();
            if ($(this).hasClass('d-step-2')) {
                $('.d-step-2').removeClass('active');
                $('.d-step-1').addClass('active');

                if ($(window).width() > 767) {
                    $('.d-step-3.routeinfo').removeClass('active');
                } else {
                }
            } else if ($(this).hasClass('d-step-3')) {
                $('.d-step-3').removeClass('active');
                if ($(window).width() < 767) {
                    $('.d-step-2').addClass('active');
                    $('.step-3-text.d-step-3').removeClass('active');
                    $('.submit.desktop').removeClass('active');
                } else {
                    $('.d-step-2').removeClass('active');
                    $('.next-step-btn.d-step-2').addClass('active');
                    $('.prev-step-btn.d-step-2').addClass('active');
                }
            }
        });

        _this.$selectDepartureLocation.on('change', function() {
            if ($(this)[0].value !== '') {
                // Hide confirm-ticket btn on change
                $('.confirm-ticket-btn').addClass('active');
                _this.$selectTicketType.prop('disabled', false);
            } else {
                // Hide confirm-ticket btn on change
                _this.$selectTicketType.prop('disabled', true);
                $('.confirm-ticket-btn').removeClass('active');
            }

            _this.setPageByLocation();
            $('.submit[name="submitButton"]').removeClass('active');

            // _this.scrollToTarget(_this.$selectTicketType);
            _this.departureNextStep = true;
        });

        _this.$selectTicketType.on('change', function() {
            var availableTickets = _this.showAvailableTicket.getMaxTickets(_this.$selectTicketType);
            _this.showAvailableTicket.refreshTicketSelect(availableTickets);

            $('.d-step-2.next-step-btn').addClass('disabled');

            if ($(this)[0].value !== '') {
                $('.d-step-2.next-step-btn').removeClass('disabled');
                $('.d-step-2.submit.desktop').removeClass('disabled');
                if ($(window).width() < 767) {
                    $('.d-step-3.routeinfo').removeClass('active');
                } else {
                    $('.d-step-3.routeinfo').addClass('active');
                }
            } else {
                $('.d-step-2.submit[name="submitButton"]').addClass('disabled');
                $('.d-step-3').removeClass('active');
            }
        });

        _this.$submitButton.each(function() {
            $(this).on('click', function() {
                if (_this.ticketForm.checkValidity()) {
                    //create hidden field so the submit actually posts
                    var hiddenField = document.createElement('input');
                    hiddenField.setAttribute('type', 'hidden');
                    hiddenField.setAttribute('name', 'submitButton');
                    hiddenField.setAttribute('value', 'submit');

                    _this.ticketForm.appendChild(hiddenField);
                    _this.ticketForm.submit();
                } else {
                    _this.ticketForm.reportValidity();
                }
            });
        });

        _this.$mobileButton.on('click', function() {
            _this.scrollToTarget($(_this.ticketForm));
        });

        _this.$stepButton.on('click', function() {
            // var $button = $(this);

            _this.nextStep(this);
        });
    },

    scrollToTarget: function(target) {
        if (target.length) {
            $('html, body').animate(
                {
                    scrollTop: target.offset().top - 200
                },
                300
            );
        }
    },

    showAvailableTicket: {
        init: function(that) {
            var _this = this;
            _this.that = that;
        },

        getAmount: function(location) {
            var _this = this,
                _that = _this.that,
                tickets = [];

            if (_that.ticketTypeObject[location]) {
                $('.step-3').removeClass('active');
                if ($('.step-3').hasClass('active')) {
                    $('.confirm-ticket-btn').addClass('active');
                }
            } else {
                $('.step-3').removeClass('active');
                $('.step2-wrapper').removeClass('active');
                $('.buttons-on-fail').addClass('active');
                $('.confirm-ticket-btn').removeClass('active');
            }

            $.each(_that.ticketTypeObject[location], function(key, element) {
                if (element.amount > 0) {
                    tickets.push(
                        '<option value="' +
                            element.id +
                            '" data-max="' +
                            element.amount +
                            '">' +
                            key +
                            '\xa0-\xa0\xa0' +
                            '\u20AC' +
                            '\xa0' +
                            element.price +
                            '</option>'
                    );
                } else if (element.amount === 0) {
                    tickets.push(
                        '<option value="' +
                            element.id +
                            '">' +
                            key +
                            '\xa0-\xa0\xa0' +
                            '\xa0' +
                            'uitverkocht' +
                            '</option>'
                    );
                }
            });

            tickets.unshift(
                '<option class="hidden" hidden value="" disabled selected>Kies ticket...</option>'
            );

            //render de select with tickets available
            _this.renderDom(tickets.join(''), location);
        },

        getMaxTickets: function(ticketSelect) {
            var _this = this,
                _that = _this.that;

            var $selectedEl = ticketSelect.find('option:selected');
            return $selectedEl.attr('data-max');
        },

        refreshTicketSelect: function(availableTickets) {
            var _this = this,
                _that = _this.that;

            // If ticketType is undefined that means that no ticket type is selected

            _that.$amoundBlockSelect.prop('disabled', availableTickets === undefined);
            _that.$amountBlock.attr('data-max', availableTickets);
            _that.$amountBlock.trigger('AmountBlock:refresh');
        },

        renderDom: function(html, location) {
            var _this = this,
                _that = _this.that;

            // Append to original select
            _that.$selectTicketType.html(html);

            // Refresh Select2
            _that.$selectTicketType.select2({
                minimumResultsForSearch: Infinity
            });
            _that.$selectTicketType.change();

            //show specific route details
            _that.$accordionRow.removeClass('show');
            $('#' + location).addClass('show');

            //hide intro text
            $('.intro-text').addClass('hide');
        }
    },

    googleMap: {
        init: function(that) {
            var _this = this;

            _this.that = that;

            _this.setStaticMap('full-1');

            _this.options = {
                zoom: 15,
                scrollwheel: false,
                disableDefaultUI: true,
                zoomControl: true
            };
        },
        setStaticMap: function(id) {
            var _this = this,
                _that = _this.that;
            //Roelovarensveen
            var baseLocation = { lat: 52.2030277, lng: 4.632 };

            var map = new google.maps.Map(document.getElementById(id), {
                zoom: 8,
                center: baseLocation,
                disableDefaultUI: true,
                zoomControl: true
            });

            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(function(position) {
                    var pos = {
                        lat: position.coords.latitude,
                        lng: position.coords.longitude
                    };
                    map.setCenter(pos);

                    var marker = new google.maps.Marker({
                        map: map,
                        position: pos,
                        title: 'Jouw locatie',
                        icon: _that.locationIcon
                    });
                });
            }

            $.each(window.locations, function(index, value) {
                var position = {
                    lat: parseFloat(value.location.fields.location_departure_maps.lat),
                    lng: parseFloat(value.location.fields.location_departure_maps.lng)
                };

                var marker = new google.maps.Marker({
                    map: map,
                    position: position,
                    title: value.location.fields.location_departure,
                    icon: _that.icon
                });

                marker.addListener('click', function() {
                    map.setCenter(marker.getPosition());

                    _that.$selectDepartureLocation.val(value.location.ID).change();

                    var departureValue = _that.$selectDepartureLocation.val();

                    _that.showAvailableTicket.getAmount(departureValue);

                    $('.departure-information-block').addClass('background');
                });
            });
        },

        setMap: function(location) {
            var _this = this,
                _that = _this.that;

            _this.getDirection(location);
            $('.departure-information-block').addClass('background');
            // _this.getMap(location);
        },

        getDirection: function(location) {
            var directionsDisplay = new google.maps.DirectionsRenderer();
            var directionsService = new google.maps.DirectionsService();

            var bounds = new google.maps.LatLngBounds();

            var mapName = $('#map-' + location);

            //set up locations array
            var locations = [
                [
                    'start',
                    parseFloat($(mapName).attr('data-latitude')),
                    parseFloat($(mapName).attr('data-longitude'))
                ],
                [
                    'end',
                    parseFloat($(mapName).attr('data-latitude-end')),
                    parseFloat($(mapName).attr('data-longitude-end'))
                ]
            ];

            //create request that will be used with the directions API
            //dont optimize waypoints, since the bus will take this actual route
            var request = {
                travelMode: google.maps.TravelMode.DRIVING,
                optimizeWaypoints: false
            };

            //set up map
            var centerPoint = new google.maps.LatLng(locations[1][1], locations[1][2]);

            if (document.getElementById('map-' + location)) {
                var map = new google.maps.Map(document.getElementById('map-' + location), {
                    zoom: 6,
                    center: centerPoint,
                    disableDefaultUI: true,
                    zoomControl: true
                });

                directionsDisplay.setMap(map);
            }

            //create each marker
            for (i = 0; i < locations.length; i++) {
                marker = new google.maps.Marker({
                    position: new google.maps.LatLng(locations[i][1], locations[i][2])
                });

                if (i == 0) {
                    // Show not available text
                    $('.intro-text.not-available').addClass('show');

                    request.origin = { lat: locations[i][1], lng: locations[i][2] };
                } else if (i == locations.length - 1) {
                    //last marker equals the destination
                    request.destination = { lat: locations[i][1], lng: locations[i][2] };
                } else {
                    //all other markers are waypoints/stopovers
                    if (!request.waypoints) request.waypoints = [];
                    request.waypoints.push({
                        location: marker.getPosition(),
                        stopover: true
                    });
                }
            }

            //finally set up the direction and display it on the map
            directionsService.route(request, function(result, status) {
                if (status == google.maps.DirectionsStatus.OK) {
                    directionsDisplay.setDirections(result);
                    $('.intro-text.not-available').removeClass('show');
                    $('.hide-on-fail').css('display', 'block');
                    $('.show-on-fail').css('display', 'none');
                } else {
                    $('select[name="ticket-type"]').select2('enable', false);
                    $('.hide-on-fail').css('display', 'none');
                    $('.show-on-fail').css('display', 'block');
                }
            });
        },

        getPosition: function(location) {
            var _this = this,
                $mapWrap = $('#map-' + location);

            _this.options.center = {
                lat: Number($mapWrap.attr('data-latitude')),
                lng: Number($mapWrap.attr('data-longitude'))
            };
        },

        getMap: function(location) {
            var _this = this,
                _that = _this.that;

            _this.map = new google.maps.Map(
                document.getElementById('map-' + location),
                _this.options
            );

            var marker = new google.maps.Marker({
                map: _this.map,
                position: _this.options.center,
                icon: _that.icon
            });
        }
    },

    nextStep: function(that) {
        var _this = this;

        if (_this.departureNextStep === false) {
            return;
        }

        $('.information-block').prop('hidden', true);
        $('.intro-usp-block').prop('hidden', true);

        var target = $(that).attr('data-target');

        $('.icon-step-' + parseInt(target - 1)).addClass('completed');
        $('.tab').removeClass('active');
        $('.icon-step-' + target).addClass('active');
        $(that)
            .closest('.step')
            .toggleClass('active');
        $('#step' + target).toggleClass('active');

        $('.intro-text.not-available').removeClass('show');
    },

    helpers: {
        init: function(that) {
            var _this = this;

            _this.that = that;
        }
    }
};
